/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DashboardSummary_commissionSummary = ReadonlyArray<{
    readonly " $fragmentRefs": FragmentRefs<"DashboardProfitView_commissionSummary">;
    readonly " $refType": "DashboardSummary_commissionSummary";
}>;
export type DashboardSummary_commissionSummary$data = DashboardSummary_commissionSummary;
export type DashboardSummary_commissionSummary$key = ReadonlyArray<{
    readonly " $data"?: DashboardSummary_commissionSummary$data;
    readonly " $fragmentRefs": FragmentRefs<"DashboardSummary_commissionSummary">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "DashboardSummary_commissionSummary",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardProfitView_commissionSummary"
    }
  ],
  "type": "CommissionSummary",
  "abstractKey": null
};
(node as any).hash = '4acd81a76595f06fdc3e2c9763034dce';
export default node;
